import wretch from "wretch";

export const api = wretch("https://kehvad-teed.herokuapp.com/", {}).resolve(
  (r) => r.json()
);
